import React from 'react'
import AuthService from '../app/service/authService'

export const AuthContext = React.createContext()
export const AuthConsumer = AuthContext.Consumer
const AuthProvider = AuthContext.Provider

class ProvedorAutenticacao extends React.Component {
    state = {
        usuarioAutenticado: null,
        isAutenticado: false,
        isLoading: true
    }

    autenticado = () => {
        return this.state.isAutenticado
    }

    iniciarSessao = (usuario) => {
        // usuário já vem com o token do backend
        AuthService.logar(usuario)
        this.setState({ isAutenticado: true, usuarioAutenticado: usuario })
    }

    encerrarSessao = () => {
        AuthService.removerUsuarioAutenticado()
        this.setState({ isAutenticado: false, usuarioAutenticado: null })
    }

    componentDidMount() {
        const usuario = AuthService.refreshSession()

        if (usuario && usuario.token) {
            this.setState({
                isAutenticado: true,
                usuarioAutenticado: usuario,
                isLoading: false
            })
        } else {
            this.setState({
                isAutenticado: false,
                usuarioAutenticado: null,
                isLoading: false
            })
        }
    }

    render() {
        if (this.state.isLoading) {
            return null // evita piscar conteúdo sem autenticação
        }

        const contexto = {
            usuarioAutenticado: this.state.usuarioAutenticado,
            isAutenticado: this.state.isAutenticado,
            iniciarSessao: this.iniciarSessao,
            encerrarSessao: this.encerrarSessao
        }

        return (
            <AuthProvider value={contexto}>
                {this.props.children}
            </AuthProvider>
        )
    }
}

export default ProvedorAutenticacao